import { useEffect, useState } from "react";
import { useGetHubSpotCloserMisalignedSlots } from "../HubSpot/useGetHubSpotCloserMisalignedSlots.ts";
import { useGetSchedulerClosers } from "../HubSpot/useGetSchedulerClosers.ts";
import {
  hasSchedulerCloserIssues,
  misalignedSlotsRange,
} from "./closerIssues.ts";

export function useCloserIssueIndicators() {
  const { getHubSpotCloserMisalignedSlots } =
    useGetHubSpotCloserMisalignedSlots();
  const { getSchedulerClosers } = useGetSchedulerClosers();
  const [hasMisalignedSlots, setHasMisalignedSlots] = useState(false);
  const [hasCloserIssues, setHasCloserIssues] = useState(false);

  useEffect(() => {
    const { from, to } = misalignedSlotsRange();
    getHubSpotCloserMisalignedSlots({
      fromIncl: from.toDate(),
      toIncl: to.toDate(),
      includeSecondaryCalendars: false,
    })
      .then((closers) => setHasMisalignedSlots((closers ?? []).length > 0))
      .catch(console.error);
  }, [getHubSpotCloserMisalignedSlots]);

  useEffect(() => {
    getSchedulerClosers()
      .then((closers) =>
        setHasCloserIssues(closers ? hasSchedulerCloserIssues(closers) : false),
      )
      .catch(console.error);
  }, [getSchedulerClosers]);

  return { hasMisalignedSlots, hasCloserIssues };
}
